import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchGiftCardList = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        commit('toggleLoadingState', false)
        return false
    } else {
        axios.post('/giftCard/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.status) {
                commit('setGiftCardList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})            
            }            
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchGiftCardAutocompleteList = ({commit}, payload) => {

    
    commit('toggleLoadingState', true)
    axios.post('/giftCard/autocomplete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setGiftCardAutocompleteList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchGiftCardData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/giftCard/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('setGiftCardData', {response: res.data.response, copy: payload.copy})   
            commit('setCustomerMasterAutocompleteList', [{
                id: res.data.response.customer_id,
                type_of_customer: res.data.response.type_of_customer,
                salutation_name: res.data.response.salutation_name,
                customer_name: res.data.response.customer_name,
                company_name:res.data.response.company_name
            }])
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetGiftCardData')
        }
        dispatch('fetchTaxSetting')

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitGiftCardData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/giftCard/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                //router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteGiftCardData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/giftCard/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else if(payload.popup) {
            } else {
                dispatch('fetchGiftCardList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/giftCard/actions.js